import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardPriceComponent } from '../../components/card-price/card-price.component';
@Component({
  selector: 'app-plans',
  standalone: true,
  imports: [
    CommonModule,
    CardPriceComponent
  ],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.scss'
})
export class PlansComponent {

}
